// src/constants/apiConfig.js
// export const API_BASE_URL = 'http://127.0.0.1:8000/api/';
// export const IMAGE_BASE_URL = 'http://127.0.0.1:8000/images/';
// export const AUDIO_BASE_URL = 'http://127.0.0.1:8000/audios/';
// export const MARDI_DEV_URL = 'http://127.0.0.1:8000/';
export const API_BASE_URL = 'https://mardi-api.mapskart.com.my/api/';
export const IMAGE_BASE_URL = 'https://mardi-api.mapskart.com.my/images/';
export const AUDIO_BASE_URL = 'https://mardi-api.mapskart.com.my/audios/';
export const MARDI_DEV_URL = 'https://agrotech-park.mardi.mapskart.com.my/';